const ANSWER = Object.freeze({
  ADVANCED: {
    ID: "ADVANCED",
    DISPLAY_TITLE: "Advanced knowledge and skills"
  },
  GOOD: {
    ID: "GOOD",
    DISPLAY_TITLE: "Good knowledge and skills"
  },
  FAIR: {
    ID: "FAIR",
    DISPLAY_TITLE: "Fair knowledge and skills"
  },
  LIMITED: {
    ID: "LIMITED",
    DISPLAY_TITLE: "Limited knowledge and skills"
  },
  NO_RESPONSE: {
    ID: "NO_RESPONSE",
    DISPLAY_TITLE: "No Response"
  }
});

export default ANSWER;
